// extracted by mini-css-extract-plugin
module.exports = {"contentForm":"support-form_contentForm__DJyTK","title":"support-form_title__ach4Z","inputsGrid":"support-form_inputsGrid__j8s_F","confirmText":"support-form_confirmText__xBg2c"};